module.exports = __webpack_public_path__ + "static/media/help_form_background_320.30c93443.jpeg";